<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  /* padding: 20px; */
  overflow-y: scroll;
}

.margin{
  color: white;
  margin: 50px;
  text-align: center;
}
.title-signup{
  font-size: 40px;
}


.no-class {
  bottom: 110%; 
  opacity: 0;
  position: absolute;
  animation-name: none;
  animation-duration: 0;
  border-radius: 0;
  width: 0;
  height: 0;
}
  

</style>

<Auth bind:this="{auth}"></Auth>


<div class="bg">
  <div class="title-signup">Welcome To The Party</div>
  <div class="margin">Thank you.  We sincerely hope you enjoy yourself here.  If you don't please send us <a href="/feedback" use:link>feedback</a>.</div>
</div>

<!-- <div class="adrop"></div> -->


<div class="next">
  <button on:click="{next}">Let's Get Started!</button>
</div>


<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import forge from "node-forge";

import Auth from "../../../../interfaces/Auth.svelte";
let auth;

import Signup from "../../../../helpers/Signup.js";
import Signin from "../../../../helpers/Signin.js";

import { onMount, onDestroy } from "svelte";
onMount(async () => {
  console.log("TEST ALL THE THINGS!!!");
  
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    document.location = "/";
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  // verify that all *Saved signup properties have been fullfilled
  // if not, take them back to the specific place that needs to be fullfilled
  let signup = localStorage.getItem("signup");
  if (signup == null) replace("/signup/profile/personal/init");
  
  signup = JSON.parse(signup);
  
  if (signup.nameSaved == false) push("/signup/profile/personal/name");
  if (signup.emailSaved == false) push("/signup/profile/personal/email");
  if (signup.emailCodeSaved == false) push("/signup/profile/personal/email-verify");
  if (signup.phoneSaved == false) push("/signup/profile/personal/phone");
  // if (signup.phoneCodeSaved == false) push("/signup/profile/personal/phone-verify");
  if (signup.usernameSaved == false) push("/signup/profile/personal/username");
  if (signup.passwordSaved == false) push("/signup/profile/personal/password");
  if (signup.distanceSaved == false) push("/signup/profile/personal/distance-away");
  if (signup.birthdaySaved == false) push("/signup/profile/personal/birthday");
  if (signup.genderSaved == false) push("/signup/profile/personal/gender");
  if (signup.agePreferenceSaved == false) push("/signup/profile/personal/age-preference");
  if (signup.lookingForSaved == false) push("/signup/profile/personal/looking-for");
  if (signup.photosSaved == false) push("/signup/profile/personal/photos");
  if (signup.interestsSaved == false) push("/signup/profile/personal/interests");
  if (signup.questionsSaved == false) push("/signup/profile/personal/questions");
  if (signup.keysSaved == false) push("/signup/profile/personal/keys");
  if (signup.locationSaved == false) push("/signup/profile/personal/location");
  
  try {
    // do a legit signin
    await Signin.now(signup.email, signup.password);
    
    // save keys to local storage
    let keys = Signup.getPersonalObject("keys");
    
    // decrypt private key
    let pkey = forge.pki.decryptRsaPrivateKey(keys.pkey, signup.password);
    pkey = forge.pki.privateKeyToPem(pkey);
    
    // save private key and cert
    localStorage.setItem("pkey", pkey);
    localStorage.setItem("cert", keys.cert);
    
    try {
      
      // connect the person that invited to the person that just signed up
      let vc = localStorage.getItem("vc"); // invite code
      let res = await auth.post("connectInvited", {vc: vc}, false);
      
    } catch (error) {
      console.log("couldn't connect invitee and inviter:", error);
    }
    
    // delete sign up
    localStorage.removeItem("signup");
    localStorage.removeItem("v");
    localStorage.removeItem("vc");
    
    // save signupComplete: true - in the future, this will definitively bypass signup for
    // a user on this device.  If a user logs in on a new device, this will also 
    // be set on the new device
    localStorage.setItem("signup", JSON.stringify({signupComplete: true}) );
    
    console.log("START THE CONFETTI");
    confettiInit();
    
  } catch (error) {
    console.log("thank you error:", error);
  }
  
});


onDestroy(async () => {
  confettiDelete();
});



let confettiCount = 150;
let confettiDivs = [];
let confettiCurDiv = 0;
let confettiTransitionEvent = whichAnimationEvent();
let confettiHandler = null;

function whichAnimationEvent() {
  let t, el = document.createElement("fakeelement");

  let animations = {
    "animation" : "animationend",
    "OAnimation" : "oAnimationEnd",
    "MozAnimation" : "animationend",
    "WebkitAnimation" : "webkitAnimationEnd",
  }

  for (let t in animations) {
    if (el.style[t] !== undefined) {
      return animations[t];
    }
  }
}


function confettiInit() {
	for (let t = 0; t < confettiCount; t++) {
		let div = document.createElement('div');
		
		div.className = "no-class";
		
		document.body.appendChild(div);
		confettiDivs.push(div);
	}
	
	setTimeout( confettiLoop, 0 );
}


function confettiDelete() {
  clearTimeout(confettiHandler);
  for (let i in confettiDivs) {
    document.body.removeChild(confettiDivs[i]);
  }
}


function confettiLoop() {
	
	confettiDivs[ confettiCurDiv ].style.left = (Math.ceil( Math.random()*95 ) )+"%";
	
	let size = Math.round( Math.random() );
  if (size == 1) {
    confettiDivs[ confettiCurDiv ].style.width = "10px";
  	confettiDivs[ confettiCurDiv ].style.height = "3px";
  } else {
  	confettiDivs[ confettiCurDiv ].style.width = "7px";
  	confettiDivs[ confettiCurDiv ].style.height = "2px";
  }
	
  let r =  Math.ceil( Math.random()*100 ) + 155;
  let g =  Math.ceil( Math.random()*100 ) + 155;
  let b =  Math.ceil( Math.random()*100 ) + 155;
  
  let colorString = "rgb("+r+","+g+","+b+")";
	
  let drop = Math.round( Math.random() );
	confettiDivs[ confettiCurDiv ].style.backgroundColor = colorString;
	confettiDivs[ confettiCurDiv ].className = "adrop" + drop;
	confettiDivs[ confettiCurDiv ].addEventListener(confettiTransitionEvent, endOfTransition);
	
	if (confettiCurDiv < confettiCount-1) {
		confettiCurDiv++;
	} else {
		confettiCurDiv = 0;
	}
	
	confettiHandler = setTimeout( confettiLoop, 150 );
}


function endOfTransition(e) {
	e.target.className = "no-class";
}


function next() {
  push("/events/popular");
}


</script>